import { useState, useEffect } from 'react';
import { Container, Input, FormGroup, Label, Row, Col } from 'reactstrap';
import { DateTime } from 'luxon';
import './App.scss';
import Timeline from './components/Timeline/Timeline';
import TopBar from './components/TopBar/TopBar';
import { useSelector } from 'react-redux';
import { selectGroupsMapping } from './state/groupsSlice';
import { selectConfig } from './state/configSlice';

function App() {
  const dateToday = DateTime.now().toISODate();
  const [from, setFrom] = useState(
    DateTime.fromISO(dateToday).minus({ weeks: 2 }).toISODate()
  );
  const [to, setTo] = useState(
    DateTime.fromISO(dateToday).plus({ weeks: 2 }).toISODate()
  );
  const [today, setToday] = useState(dateToday);
  const [duration, setDuration] = useState(10);
  const [type, setType] = useState('days');
  const [timeline, setTimeline] = useState([]);
  const groups = useSelector(selectGroupsMapping);
  const config = useSelector(selectConfig);

  useEffect(() => {
    if (from && to) {
      const date1 = DateTime.fromISO(to);
      const date2 = DateTime.fromISO(from);
      const diff = date1.diff(date2, [type]);
      const diffNum = Math.abs(diff.toObject()[type]);
      const t = [];

      for (let i = 0; i < diffNum + 1; i++) {
        switch (type) {
          case 'days':
            t.push(DateTime.fromISO(from).plus({ days: i }).toISODate());
            break;

          case 'weeks':
            if (i === 0) {
              t.push(
                DateTime.fromISO(from)
                  .plus({ days: i * 7 })
                  .toISODate()
              );
            } else {
              t.push(
                DateTime.fromISO(from)
                  .plus({ days: i * 7 })
                  .startOf('week')
                  .toISODate()
              );
            }
            break;

          case 'months':
            t.push(DateTime.fromISO(from).plus({ months: i }).toISODate());
            break;

          case 'years':
            t.push(DateTime.fromISO(from).plus({ years: i }).toISODate());
            break;

          default:
            break;
        }
      }

      setDuration(diffNum);
      setTimeline(t);
    }
  }, [from, to, duration, type]);

  return (
    <Container>
      <TopBar />

      {config.isPreview ? (
        <Row style={{ minHeight: '100px' }}>
          <Col></Col>
        </Row>
      ) : (
        <Row style={{ minHeight: '100px' }}>
          <Col>
            <h3>
              Timeline ({timeline.length} {type})
            </h3>
          </Col>

          <Col>
            <Row>
              <Col>
                <FormGroup>
                  <Label for="selectType">Type</Label>
                  <Input
                    id="selectType"
                    name="type"
                    type="select"
                    defaultValue={type}
                    onChange={e => setType(e.target.value)}
                  >
                    <option value="years">Years</option>
                    <option value="months">Months</option>
                    <option value="weeks">Weeks</option>
                    <option value="days">Days</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label for="inputFrom">From</Label>
                  <Input
                    id="inputFrom"
                    name="from"
                    placeholder="From"
                    type="date"
                    onChange={e => setFrom(e.target.value)}
                    defaultValue={from}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label for="inputTo">To</Label>
                  <Input
                    id="inputTo"
                    name="to"
                    placeholder="To"
                    type="date"
                    onChange={e => setTo(e.target.value)}
                    defaultValue={to}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label for="inputTo">Today</Label>
                  <Input
                    id="inputTo"
                    name="today"
                    placeholder="Today"
                    type="date"
                    onChange={e => setToday(e.target.value)}
                    defaultValue={today}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Col>
        </Row>
      )}

      <Timeline
        duration={duration}
        groups={groups}
        from={from}
        to={to}
        today={today}
        type={type}
        timeline={timeline}
      />

      <br />
      <br />
      <hr />
      <div className="text-center">
        &copy; 2024 Roadmap,{' '}
        <a
          href="https://github.com/sf3r4/roadmap/blob/main/LICENSE"
          target="_blank"
          rel="noreferrer"
          className="text-dark"
        >
          <i className="bi bi-github" />
        </a>
      </div>
      <div className="text-center">
        <a
          href="https://github.com/sf3r4/roadmap/blob/main/LICENSE"
          target="_blank"
          rel="noreferrer"
          className="text-dark"
        >
          MIT License
        </a>
      </div>
      <br />
      <br />
    </Container>
  );
}

export default App;
